import axios from "axios";

import {
  loginSuccess,
  logoutUserSuccess,
  apiError,
  reset_login_flag,
} from "./reducer";

import { appInitService } from "../../../services/AppInitService";

// NOTE: loginUser is no longer used - OTP flow handles login via requestEmailOtp/verifyEmailOtp
// This function is kept for backward compatibility but should not be called
export const loginUser = (user: any, history: any) => async (dispatch: any) => {
  // Legacy login method not supported - use OTP flow instead
  // No-op: This function should not be called
  return;
};

export const logoutUser = () => async (dispatch: any) => {
  try {
    // Clear axios authorization header
    delete axios.defaults.headers.common["Authorization"];
    
    // Reset AppInitService state
    appInitService.reset();

    // Dispatch logout - Redux Persist will automatically clear sessionStorage
    dispatch(logoutUserSuccess(true));
    
    // NOTE: Removed manual storage clearing - Redux Persist handles this automatically
  } catch (error: any) {
    dispatch(apiError(error));
  }
};

export const socialLogin =
  (type: any, history: any) => async (dispatch: any) => {
    // Social login not implemented for API flow - placeholder only
    return null;
  };

export const resetLoginFlag = () => async (dispatch: any) => {
  try {
    const response = dispatch(reset_login_flag());
    return response;
  } catch (error: any) {
    dispatch(apiError(error));
  }
};
